import '@fontsource/inter/latin-400.css';
import '@fontsource/inter/latin-500.css';
import '@fontsource/inter/latin-600.css';
import '@fontsource/inter/latin-700.css';
import '@alveolemtl/alveole-components/dist/style.css';
import '../tailwind.css';
import '../theme/globalStyle.css.js';

import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import { Layout, PAGE_COMPONENTS } from './ssg-app.js';

const rootEl = document.getElementById('root') as HTMLElement;
const page = rootEl.querySelector('[data-ssg-page]')?.getAttribute('data-ssg-page') ?? '';
const component = PAGE_COMPONENTS[page];

createRoot(rootEl).render(
  <HelmetProvider>
    <BrowserRouter>
      <Layout page={page}>{component}</Layout>
    </BrowserRouter>
  </HelmetProvider>,
);
